import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgNominationBookingType({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M13.55 11.5a.75.75 0 01.743.648l.007.102v2.8a.75.75 0 01-.648.743l-.102.007h-5.2a.75.75 0 01-.743-.648L7.6 15.05v-2.8a.75.75 0 011.493-.102l.007.102-.001 2.049H12.8V12.25a.75.75 0 01.648-.743l.102-.007zM10.95.2a1.75 1.75 0 011.744 1.606l.006.144v3a.75.75 0 01-1.493.102L11.2 4.95v-3a.25.25 0 00-.193-.243L10.95 1.7h-9a.25.25 0 00-.243.193L1.7 1.95v10a.25.25 0 00.193.243l.057.007h3a.75.75 0 01.102 1.493l-.102.007h-3a1.75 1.75 0 01-1.744-1.606L.2 11.95v-10A1.75 1.75 0 011.806.206L1.95.2h9zm.312 6.668l.1.056 4.2 2.77A.75.75 0 0114.835 11l-.097-.055-3.77-2.486-3.781 2.701a.75.75 0 01-.975-.089l-.071-.085a.75.75 0 01.089-.975l.085-.071 4.2-3a.75.75 0 01.748-.072zM6.45 6.2a.75.75 0 01.102 1.493L6.45 7.7h-2.5a.75.75 0 01-.102-1.493L3.95 6.2h2.5zm2.5-3a.75.75 0 01.102 1.493L8.95 4.7h-5a.75.75 0 01-.102-1.493L3.95 3.2h5z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgNominationBookingType.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgNominationBookingType.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgNominationBookingType svgRef={ref} {...props} />
));
export default ForwardRef;
